export function empty() {
	const links = Array.from( document.querySelectorAll( 'a[href=""], a[href="#"], a:not([href])' ) );

	console.info( `There are ${ links.length } empty links on this page`, links );

	return links;
}

/**
 *
 * @returns
 */
export function external( target = '_blank' ) {
	const links = Array.from( document.querySelectorAll( 'a[href]:not([target])' ) ).filter( ( link ) => {
		const isEmpty  = Boolean( link.getAttribute( 'href' ) ) === false;
		const isLocal  = link.href.startsWith( document.location.origin );
		const isAnchor = link.getAttribute( 'href' ).startsWith( '#' );

		if ( isEmpty || isLocal || isAnchor ) {
			return false;
		}

		return true;
	} );

	if ( target ) {
		links.forEach( ( link ) => {
			if ( target && ! link.getAttribute( 'target' ) ) {
				link.target = target;
			}
		} );
	}

	console.info( 'External Links', links );

	return links;
}

// if ( [ 'ready', 'interactive' ].includes( document.readyState ) ) {
// 	external();
// } else {
// 	document.addEventListener( 'DOMContentLoaded', external );
// }
